import { render, staticRenderFns } from "./CustomServicesCard.vue?vue&type=template&id=03397146&scoped=true&"
import script from "./CustomServicesCard.vue?vue&type=script&lang=js&"
export * from "./CustomServicesCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomServicesCard.vue?vue&type=style&index=0&id=03397146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03397146",
  null
  
)

export default component.exports